export default {
  path: ":alias/messages",
  component: resolve => require(["@/views/messages"], resolve),
  children: [
    {
      path: "list",
      component: resolve => require(["@/views/messages/list"], resolve)
    }
  ]
};
